import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { DesignTypePage } from "@/features/mbc-admin/design-types/DesignTypePage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/admin/design-types/$designTypeId",
)({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Design type");
  const { designTypeId } = Route.useParams();

  return <DesignTypePage designTypeId={Number(designTypeId)} />;
}
